module.exports = __webpack_public_path__ + "img/avatar7.b75d6384.jpg";